import { render, staticRenderFns } from "./NosotrosPage.vue?vue&type=template&id=18866abd&scoped=true"
import script from "./NosotrosPage.vue?vue&type=script&lang=js"
export * from "./NosotrosPage.vue?vue&type=script&lang=js"
import style0 from "./NosotrosPage.vue?vue&type=style&index=0&id=18866abd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18866abd",
  null
  
)

export default component.exports